export const buildCategoriesProp = (id: string) => {
  return id
    .split('/')
    .filter((category) => category !== '')
    .map((category) => `categoryId=${category}`)
    .join('&')
}
